import { render, staticRenderFns } from "./IssueProfileOffice.vue?vue&type=template&id=2380c156&"
import script from "./IssueProfileOffice.vue?vue&type=script&lang=js&"
export * from "./IssueProfileOffice.vue?vue&type=script&lang=js&"
import style0 from "./IssueProfileOffice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports